(() => {
  const dialog = document.getElementById('wonder-quickshop');
  const content = dialog?.querySelector('[data-quickshop-content]');
  let trigger;
  let requestNumber = 0;
  function initializeOptions(root) {
    root.querySelectorAll('[data-option-controls]').forEach(controls => {
      const section = controls.closest('[data-product-section]');
      const selector = section.querySelector('[data-variant-select]');
      const selected = selector.selectedOptions[0];
      // Populate from the variant rather than relying on option-value object coercion.
      controls.querySelectorAll('[data-option-position]').forEach(group => {
        const value = selected.getAttribute('data-option-' + group.dataset.optionPosition);
        group.querySelectorAll('[data-option-input]').forEach(input => {
          if (input.tagName === 'SELECT') input.value = value;
          else input.checked = input.value === value;
        });
      });
      controls.hidden = false;
      selector.hidden = true;
      section.querySelector('[data-variant-fallback-label]').hidden = true;
    });
  }
  function initializeSizeLabels(root) {
    root.querySelectorAll('[data-size-values]').forEach(el => {
      const values = JSON.parse(el.dataset.sizeValues).map(value => typeof value === 'string' ? value : value.name);
      const number = value => Number(value.match(/(\d+(\.\d+)?)/)?.[0]);
      const numeric = values.every(value => /\d/.test(value));
      if (numeric) values.sort((a,b) => number(a)-number(b));
      el.textContent = values.length === 1 ? values[0] : values.length === 2 || numeric ? `${values[0]} – ${values[values.length-1]}` : values.join(', ');
    });
  }
  initializeOptions(document);
  initializeSizeLabels(document);
  function close() { requestNumber++; dialog.close(); trigger?.focus(); }
  dialog?.querySelector('.wonder-dialog-close').addEventListener('click', close);
  dialog?.addEventListener('cancel', () => { requestNumber++; trigger?.focus(); });
  async function showPage(url, selector, cart = false) {
    const request = ++requestNumber;
    content.replaceChildren();
    const status = document.createElement('p'); status.setAttribute('role','status'); status.textContent = 'Loading…'; content.append(status);
    dialog.toggleAttribute('data-cart', cart);
    dialog.setAttribute('aria-label', cart ? 'Your shopping cart' : 'Choose product options');
    dialog.querySelector('.wonder-dialog-close').setAttribute('aria-label', cart ? 'Close shopping cart' : 'Close product options');
    if (!dialog.open) dialog.showModal();
    try {
      const response = await fetch(url, {credentials:'same-origin'});
      if (!response.ok) throw new Error('Page unavailable');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const section = parsed.querySelector(selector);
      if (!section) throw new Error('Page unavailable');
      if (request !== requestNumber || !dialog.open) return;
      // No inline scripts are imported from the fetched document.
      section.querySelectorAll('script').forEach(el => el.remove());
      content.replaceChildren(section);
      if (cart) {
        const count = [...section.querySelectorAll('[name="updates[]"]')].reduce((sum, input) => sum + Number(input.value), 0);
        document.querySelectorAll('a.wonder-cart-link').forEach(link => {
          link.setAttribute('aria-label', `Cart, ${count} items`);
          const badge = link.querySelector('span'); if (badge) {badge.textContent = String(count);badge.hidden = count === 0;}
        });
      }
      initializeOptions(section);
      dialog.querySelector('.wonder-dialog-close').focus();
    } catch {
      if (request !== requestNumber || !dialog.open) return;
      content.replaceChildren();
      const link = document.createElement('a'); link.href = url; link.className='wonder-button'; link.textContent = cart ? 'Open Cart' : 'Open Product'; content.append(link);
    }
  }
  document.addEventListener('click', e => {
    if (!(e.target instanceof Element)) return;
    const link = e.target.closest('a[data-quickshop], a.wonder-cart-link');
    if (link && dialog?.showModal && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey && e.button === 0) {
      e.preventDefault(); trigger=link;
      const cart = link.matches('.wonder-cart-link');
      showPage(link.href, cart ? '#main-content > .shopify-section' : '[data-product-section]', cart);
    }
    const step = e.target.closest('[data-quantity-step]');
    if (step) {
      const input = step.closest('form').querySelector('[name="quantity"]');
      input.value = Math.max(Number(input.min) || 1, (Number(input.value) || 1) + Number(step.dataset.quantityStep));
    }
    const thumb = e.target.closest('[data-gallery-image]');
    if (thumb) {
      const section = thumb.closest('[data-product-section]');
      if (thumb.dataset.galleryVariant) {
        const selector = section.querySelector('[data-variant-select]');
        selector.disabled = false;
        selector.value = thumb.dataset.galleryVariant;
        initializeOptions(section);
        selector.dispatchEvent(new Event('change', {bubbles:true}));
      }
      section.querySelectorAll('[data-gallery-image]').forEach(item => item.removeAttribute('aria-current'));
      thumb.setAttribute('aria-current', 'true');
      const image=section.querySelector('.wonder-selected-image');
      if(image){image.src=thumb.dataset.galleryImage;image.removeAttribute('srcset');image.alt=thumb.dataset.galleryAlt;}
    }
  });
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.wonder-product-form') || !dialog?.showModal) return;
    e.preventDefault();
    const button = form.querySelector('[data-add-button]');
    if (button.disabled) return;
    const feedback = form.querySelector('[data-cart-feedback]');
    const data = new FormData(form);
    button.disabled = true; button.textContent = 'Adding…';
    feedback.hidden = true;
    try {
      const endpoint = new URL(form.action, location.href);
      endpoint.pathname = endpoint.pathname.replace(/\/add\/?$/, '/add.js');
      const response = await fetch(endpoint, {method:'POST', credentials:'same-origin', body:data, headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This item could not be added. Please try again.');
      const cartLink = document.querySelector('a.wonder-cart-link');
      trigger = cartLink || button;
      await showPage(cartLink?.href || '/cart', '#main-content > .shopify-section', true);
    } catch (error) {
      feedback.textContent = error.message || 'Unable to connect. Please check your cart before trying again.';
      feedback.hidden = false;
    } finally {
      const available = form.querySelector('[data-variant-select]').selectedOptions[0]?.dataset.available === 'true';
      button.disabled = !available; button.textContent = available ? 'Add to Cart' : 'Sold out';
    }
  });
  document.addEventListener('change', e => {
    if (e.target instanceof Element && e.target.matches('[data-option-input]')) {
      const section = e.target.closest('[data-product-section]');
      const selector = section.querySelector('[data-variant-select]');
      const groups = [...section.querySelectorAll('[data-option-position]')];
      const selected = groups.map(group => ({position:group.dataset.optionPosition, value:group.querySelector('select, input:checked')?.value}));
      const match = [...selector.options].find(option => selected.every(choice => option.getAttribute('data-option-' + choice.position) === choice.value));
      const button = section.querySelector('[data-add-button]');
      if (!match) {
        selector.disabled = true; button.disabled = true; button.textContent = 'Unavailable';
        section.querySelector('[data-variant-price]').textContent = 'This combination is unavailable';
        return;
      }
      selector.disabled = false; selector.value = match.value;
      selector.dispatchEvent(new Event('change', {bubbles:true}));
      return;
    }
    if (!(e.target instanceof HTMLSelectElement) || !e.target.matches('[data-variant-select]')) return;
    const option=e.target.selectedOptions[0], section=e.target.closest('[data-product-section]');
    section.querySelector('[data-variant-price]').textContent=option.dataset.price;
    const size = section.querySelector('[data-selected-size]'); if (size) size.textContent = 'Size: ' + option.getAttribute('data-option-' + size.dataset.sizePosition);
    const button=section.querySelector('[data-add-button]');
    button.disabled=option.dataset.available!=='true'; button.textContent=button.disabled?'Sold out':'Add to Cart';
    if(option.dataset.image){const image=section.querySelector('.wonder-selected-image');if(image){image.src=option.dataset.image;image.removeAttribute('srcset');}}
    section.querySelectorAll('[data-gallery-image]').forEach(thumb => {
      if (thumb.dataset.galleryImage === option.dataset.image) thumb.setAttribute('aria-current','true');
      else thumb.removeAttribute('aria-current');
    });
    if(!e.target.closest('dialog')){const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);}
  });
  document.querySelectorAll('.wonder-desktop-nav details').forEach(menu => {
    let closeTimer;
    menu.addEventListener('mouseenter', () => {
      if (!matchMedia('(hover: hover)').matches) return;
      clearTimeout(closeTimer); menu.open = true;
    });
    menu.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => {menu.open = false;}, 180); });
  });
  document.addEventListener('click', e => {
    document.querySelectorAll('.wonder-header details[open], .wonder-sort-menu[open]').forEach(menu => {if (!menu.contains(e.target)) menu.open = false;});
  });
  document.querySelectorAll('.wonder-faq details').forEach(item => {
    item.addEventListener('toggle', () => {if (item.open) item.parentElement.querySelectorAll('details').forEach(other => {if (other !== item) other.open = false;});});
  });
  document.addEventListener('keydown', e => {
    if(e.key==='Escape' && !dialog?.open) document.querySelectorAll('.wonder-header details[open], .wonder-sort-menu[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});
  });
})();

// Cart enhancements retain native forms and remove links when JavaScript is unavailable.
(() => {
  document.documentElement.classList.add('wonder-cart-enhanced');
  let busy = false;
  let pending;
  const timers = new WeakMap();
  function checkoutState(root, disabled) {
    root.querySelectorAll('[name="checkout"]').forEach(button => { button.disabled = disabled; });
  }
  async function changeQuantity(root, row, quantity, focusKind) {
    if (busy || !Number.isInteger(quantity) || quantity < 0) return;
    busy = true;
    clearTimeout(timers.get(root));
    const key = row.dataset.cartKey;
    const status = root.querySelector('[data-cart-status]');
    status.textContent = 'Updating your cart…';
    const form = root.querySelector('form');
    form.setAttribute('aria-busy', 'true');
    root.querySelectorAll('button,input').forEach(el => {el.disabled = true;});
    let changed = false;
    try {
      const endpoint = new URL(root.dataset.cartUrl.replace(/\/$/, '') + '/change.js', location.origin);
      const response = await fetch(endpoint, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'This quantity is not available.');
      changed = true;
      const page = await fetch(root.dataset.cartUrl, {credentials:'same-origin',cache:'no-store'});
      if (!page.ok) throw new Error('Unable to refresh the cart.');
      const next = new DOMParser().parseFromString(await page.text(),'text/html').querySelector('[data-cart-root]');
      if (!next) throw new Error('Unable to refresh the cart.');
      next.querySelectorAll('script').forEach(el => el.remove());
      // If the drawer was closed while saving, leave the underlying page untouched.
      if (!root.isConnected) return;
      root.replaceWith(next);
      next.querySelector('[data-cart-status]').textContent = '';
      document.querySelectorAll('a.wonder-cart-link').forEach(link => {
        link.setAttribute('aria-label', `Cart, ${result.item_count} items`);
        const badge = link.querySelector('span');
        if (badge) {badge.textContent = String(result.item_count);badge.hidden = result.item_count === 0;}
      });
      const nextRow = [...next.querySelectorAll('[data-cart-key]')].find(el => el.dataset.cartKey === key);
      const focusTarget = nextRow?.querySelector(focusKind || '[data-cart-quantity]') || next.querySelector('[name="checkout"], .wonder-cart-empty a');
      if (!next.closest('dialog') || next.closest('dialog').open) focusTarget?.focus({preventScroll:true});
    } catch (error) {
      status.textContent = changed ? 'Your change was saved, but the cart could not refresh. Open the cart again before checking out.' : (error.message || 'Could not update your cart. Check your connection and try again.');
      root.querySelectorAll('button,input').forEach(el => {el.disabled = false;});
      root.querySelectorAll('[data-cart-step="-1"]').forEach(el => {el.disabled = Number(el.closest('[data-cart-key]').querySelector('input').value) <= 1;});
      checkoutState(root,true);
      const recovery = document.createElement('a');
      recovery.href = root.dataset.cartUrl; recovery.textContent = ' Review cart'; recovery.style.textDecoration = 'underline'; status.append(recovery);
      root.querySelector('.wonder-cart-update')?.removeAttribute('hidden');
      form.removeAttribute('aria-busy');
    } finally {busy = false; pending = undefined;}
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const root = event.target.closest('[data-cart-root]');
    if (!root) return;
    const continueLink = event.target.closest('[data-cart-continue]');
    if (continueLink && root.closest('dialog')) {event.preventDefault();root.closest('dialog').querySelector('.wonder-dialog-close').click();return;}
    const step = event.target.closest('[data-cart-step]');
    const remove = event.target.closest('[data-cart-remove]');
    if (!step && !remove) return;
    event.preventDefault();
    if (busy) return;
    const row = (step || remove).closest('[data-cart-key]');
    const input = row.querySelector('[data-cart-quantity]');
    const quantity = remove ? 0 : Math.max(1, Number(input.value) + Number(step.dataset.cartStep));
    pending = changeQuantity(root,row,quantity,step ? `[data-cart-step="${step.dataset.cartStep}"]` : null);
  });
  document.addEventListener('input', event => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-cart-quantity]')) return;
    const input = event.target, root = input.closest('[data-cart-root]');
    clearTimeout(timers.get(root)); checkoutState(root,true);
    if (!input.checkValidity() || !Number.isInteger(Number(input.value))) {
      root.querySelector('[data-cart-status]').textContent = 'Enter a whole-number quantity of 1 or more, or use Remove.'; return;
    }
    timers.set(root,setTimeout(() => {pending = changeQuantity(root,input.closest('[data-cart-key]'),Number(input.value));},500));
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.wonder-cart-form')) return;
    if (busy || pending) {event.preventDefault();return;}
    // Native submit preserves the final typed quantities even if Enter is pressed before debounce.
    clearTimeout(timers.get(form.closest('[data-cart-root]')));
  });
})();
